import { IconButton } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { useTheme } from "styled-components";
import { useAppDispatch, useAppSelector } from "../../Store";
import { useBotConfigStore } from "../../Store/Slices/ChatbotSlices/BotConfigSlice";
import { allMessagesStore } from "../../Store/Slices/socket/AllMessagesSlice";
import {
  botInfoStore,
  setOpenStatus,
} from "../../Store/Slices/socket/BotInfoSlice";
import {
  StyledWidgetHeader,
  WidgetHeaderBrand,
  WidgetHeaderBrandTitle,
  WidgetHeaderRight,
  WidgetHeaderStatus,
} from "../Styles/StyledScreens";
import {
  AppLanguageSelector,
  AppRenderNotificationMenu
} from "../appComponents/Features";
import AppRenderQuickMenuHeader from "../appComponents/Features/AppRenderQuickMenuHeader";
import { AppMaterialIcons } from "../appComponents/Icons";
import AppEndChatFeedback from "../appComponents/UtilsComponents/AppEndChatFeedback";
import AppRestartChat from "../appComponents/UtilsComponents/AppRestartChat";
import { PreviewType } from "../utils/Enum";
import { sendDataToParent } from "../utils/utils";

interface Props {
  setShowStartScreen?: (value: boolean) => void;
  onFormSubmitted?: () => void;
}

const Header: React.FC<Props> = ({ setShowStartScreen, onFormSubmitted }) => {
  const theme:any=useTheme();
  const dispatch = useAppDispatch();
  const { widgetPreviewType, isBotSetToFullScreen } = useSelector(botInfoStore);
  const { botConfig } = useSelector(useBotConfigStore);
  const { typingStatus } = useAppSelector(allMessagesStore);

  const handleCloseChat = () => {
    const alwaysOpen = botConfig?.config?.always_open ?? false;
    !alwaysOpen && dispatch(setOpenStatus(false));
    
    const enableOnChatbotCloseEvent = botConfig?.config?.enable_on_chatbot_close_event ?? false;
    enableOnChatbotCloseEvent && sendDataToParent("onChatbotClose", "close");
  };
  return (
    <StyledWidgetHeader>
      <AppRenderQuickMenuHeader />
      <WidgetHeaderBrand>
        <img
          src={botConfig.config?.company_logo?.source}
          alt={botConfig?.chatbot?.name}
        />
        <div className="titleBox">
          <WidgetHeaderBrandTitle>
            {botConfig?.chatbot?.name}
          </WidgetHeaderBrandTitle>
          <WidgetHeaderStatus>{typingStatus || ""}</WidgetHeaderStatus>
        </div>
      </WidgetHeaderBrand>
      <WidgetHeaderRight>
        <AppLanguageSelector setShowStartScreen={setShowStartScreen} onFormSubmitted={onFormSubmitted} />
        <AppRenderNotificationMenu />
        {isBotSetToFullScreen ? null : (
          <IconButton
            aria-label="minimize chat"
            onClick={() => {
              handleCloseChat();
            }}
            disabled={
              widgetPreviewType === PreviewType.getaWidgetPreview ? true : false
            }
          >
            <AppMaterialIcons
              iconName="ExpandMore"
              style={{
                color: theme?.components?.header?.text?.color,
                fontSize: "26px",
              }}
            />
          </IconButton>
        )}
        {widgetPreviewType === PreviewType.getaWidgetPreview ||
        isBotSetToFullScreen ? null : (
            <AppEndChatFeedback />
        )}
        {isBotSetToFullScreen ? <AppRestartChat /> : null}
      </WidgetHeaderRight>
    </StyledWidgetHeader>
  );
};

export default Header;
